import Enums from "../../../enums/enums";
const state = {
  setForgotPwdLoadingStatusType: Enums.LoadingStatusType.None,
  forgotPwd: null,
  getForgotPwdLoadingStatusType: Enums.LoadingStatusType.None,
  resetPwdLoadingStatusType: Enums.LoadingStatusType.None,
};

const getters = {
  GetSetForgotPwdLoadingStatusType: (state) => {
    return state.setForgotPwdLoadingStatusType;
  },
  GetForgotPwd: (state) => {
    return state.forgotPwd;
  },
  GetForgotPwdLoadingStatusType: (state) => {
    return state.getForgotPwdLoadingStatusType;
  },
  GetResetPwdLoadingStatusType: (state) => {
    return state.resetPwdLoadingStatusType;
  },
};
export { state, getters };
